import axios from "axios";
import { reactive, ref } from "vue";
import { loading, errors, toast, meta, loadingBtn } from "./shared";

export default function useAuth(navigation) {
  const enterCode = ref(false);
  const timeout = ref(null);
  const editProfile = reactive({});

  const login = async (user) => {
    loadingBtn.value = true;
    try {
      const response = await axios.post("login", user);
      loadingBtn.value = false;
      const data = response.data.data;
      toast.success(response.data.message);
      return data;
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
      return null;
    }
  };

  const verification = async (user) => {
    loadingBtn.value = true;
    try {
      const response = await axios.post("verification", user);
      const data = response.data.data;
      loadingBtn.value = false;
      toast.success(response.data.message);
      return data;
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
      return null;
    }
  };

  const create = async () => {
    errors.value = "";
    loading.value = true;
    await axios
      .get("register")
      .then((res) => {
        loading.value = false;
        Object.assign(meta, res.data);
      })
      .catch((error) => {
        window.networkError(error);
        errors.value = error;
        loading.value = false;
      });
  };

  const register = async (user) => {
    loadingBtn.value = true;
    try {
      const response = await axios.post("register", user);
      loadingBtn.value = false;
      const data = response.data;
      if (data.error) toast.error(data.message);
      else {
        enterCode.value = true;
        starTimer(data.timeout);
        toast.success(data.message);
      }
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

  const getProfile = async () => {
    errors.value = "";
    loading.value = true;
    try {
      const response = await axios.get("user");
      loading.value = false;
      const data = response.data.data;
      Object.assign(editProfile, data);
      return data;
    } catch (e) {
      errors.value = e;
      loading.value = false;
      return null;
    }
  };
  const notificationCount = async () => {
    await axios.get("notification/count").then((res) => {
      const auth = useAuthStore();
      auth.user.notification_count = res.data.count;
    });
  };

  const updateProfile = async () => {
    window.progressDialog.value = true;
    await axios
      .put("user", editProfile)
      .then((res) => {
        const data = res.data.data;
        const auth = useAuthStore();
        auth.setUser(data);
        toast.success(res.data.message);
        window.progressDialog.value = false;
      })
      .catch((error) => {
        window.networkError(error);
        window.progressDialog.value = false;
      });
  };

  const storeDevice = async (token) => {
    const payload = {
      token: token,
      app_version: import.meta.env.VITE_CLIENT_VERSION,
    };
    await axios.post("user/device-info", payload).then((res) => {
      localStorage.setItem("firebase_token", token);
    });
  };

  const uploadAvatar = async (image) => {
    window.progressDialog.value = true;
    const file = new FormData();
    file.append("image", image);
    file.append("type", "avatar");
    file.append("store", "1");
    await axios
      .post("user/image", file, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        const auth = useAuthStore();
        editProfile.image = res.data.image;
        auth.user.image = res.data.image;
        window.progressDialog.value = false;
        toast.success(res.data.message);
      })
      .catch((error) => {
        window.networkError(error);
        window.progressDialog.value = false;
      });
  };

  const resetForm = () => {
    enterCode.value = false;
    timeout.value = null;
  };

  const forgetPassword = async (user) => {
    loadingBtn.value = true;
    await axios
      .post("password/forget", user)
      .then((res) => {
        loadingBtn.value = false;
        toast.success(res.data.message);
      })
      .catch((e) => {
        loadingBtn.value = false;
        networkError(e);
      });
  };

  const resetPassword = async (user) => {
    loadingBtn.value = true;
    try {
      const res = await axios.post("password/reset", user);
      loadingBtn.value = false;
      const data = res.data.data;
      toast.success(res.data.message);
      return data;
    } catch (e) {
      loadingBtn.value = false;
      networkError(e);
      return null;
    }
  };

  const logout = async () => {
    window.progressDialog.value = true;
    try {
      const res = await axios.post("logout");
      window.progressDialog.value = false;
      toast.success(res.data.message);
      return res.data;
    } catch (e) {
      window.networkError(e);
      window.progressDialog.value = false;
      return null;
    }
  };

  const starTimer = (duration) => {
    duration = duration * 60;
    console.log(duration);
    
    timeout.value =
      window.i18n["Request again"] + " (0" + duration / 60 + ":00)";
    duration--;
    let timer = duration,
      minutes,
      seconds;
    let interval = setInterval(() => {
      
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      timeout.value =
        window.i18n["Request again"] + " (" + minutes + ":" + seconds + ")";
      if (timer < 0) {
        timeout.value = null;
        clearInterval(interval);
      }
      timer--;
    }, 1000);
  };

  return {
    login,
    verification,
    create,
    register,
    getProfile,
    notificationCount,
    forgetPassword,
    resetPassword,
    logout,
    resetForm,
    storeDevice,
    updateProfile,
    uploadAvatar,
    starTimer,
    enterCode,
    timeout,
    editProfile,
  };
}
